import { GeneralLedger } from "./general-ledger";
import { SystemField } from "./system-field";

export class AccountingBook extends SystemField {
     name?:string;
     code?:string;
     ledger_type?:string;
     comments?:string;

     //relationship
     general_ledgers?:GeneralLedger[];
}
